import { render, staticRenderFns } from "./GenEdit.vue?vue&type=template&id=7d88a1f4"
import script from "./GenEdit.vue?vue&type=script&lang=js"
export * from "./GenEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports